import { Show, type JSX } from "solid-js";
import { Icon, type IconName } from "../icon/Icon";

export type EmptyStateIllustrationProps = {
  primaryIcon: Extract<
    IconName,
    | "dragAndDrop"
    | "database"
    | "puzzle"
    | "rulesIcon"
    | "mail"
    | "document"
    | "folder"
    | "clipboard-copy"
    | "lockClosed"
    | "userCircle"
    | "webhook"
    | "userGroup"
  >;
  secondaryIcon?: Extract<IconName, "search">;
};

const EmptyStateIllustration = (props: EmptyStateIllustrationProps): JSX.Element => (
  <div class="flex size-30 items-center justify-center rounded-full bg-illustration-bg">
    <div class="relative">
      <Icon type="solid" name={props.primaryIcon} size="3xl" class="icon-illustration-icon" />
      <Show when={props.secondaryIcon}>
        {(secondaryIcon) => (
          <Icon
            type="solid"
            name={secondaryIcon()}
            size="2xl"
            class="absolute top-1 -right-3 icon-illustration-icon-subtle"
          />
        )}
      </Show>
    </div>
  </div>
);

export default EmptyStateIllustration;
